import { render, staticRenderFns } from "./IndustrySolution.vue?vue&type=template&id=1b4a8a15&scoped=true&"
import script from "./IndustrySolution.vue?vue&type=script&lang=js&"
export * from "./IndustrySolution.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySolution.vue?vue&type=style&index=0&id=1b4a8a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a8a15",
  null
  
)

export default component.exports